import React, { useState, useEffect } from "react";
import Parser from "../../parser";
import HTMLParser from "../../htmlParser";
require("../../../styles/accordion.scss");
const AccordionItem = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("details", { className: props.attributes.className, id: props.anchor || props.attributes.anchor, open: props.isOpen, onToggle: (e) => {
                if (e.target.hasAttribute("open")) {
                    props.toggle();
                }
            } },
            React.createElement("summary", null, props.attributes.title),
            React.createElement("div", { className: "accordeon-content" },
                React.createElement(Parser, { structure: props.innerBlocks })))));
};
const Accordion = (props) => {
    const { isFaq, isMulti } = props.attributes;
    const [isOpen, setOpen] = useState([]);
    useEffect(() => {
        let defaultOpen = [];
        props.innerBlocks.forEach((e, i) => {
            if (e.attributes.defaultOpen) {
                defaultOpen.push(i);
            }
        });
        setOpen(defaultOpen);
    }, []);
    const onToggle = (i) => {
        let openItems = [...isOpen].filter((e) => e !== i);
        if (isMulti) {
            openItems.push(i);
        }
        else {
            openItems = [i];
        }
        setOpen(openItems);
    };
    return (React.createElement(React.Fragment, null,
        props.innerBlocks.map((e, i) => {
            return (React.createElement(AccordionItem, { ...e, style: i === 0 ? props.style : {}, key: i, isOpen: isOpen.includes(i), toggle: () => {
                    onToggle(i);
                } }));
        }),
        isFaq ? (React.createElement(HTMLParser, null,
            React.createElement("script", { type: "application/ld+json" }, JSON.stringify({
                "@context": "http://schema.org/",
                "@type": "FAQPage",
                mainEntity: props.innerBlocks.map((e) => ({
                    "@type": "Question",
                    name: e.title,
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: e.innerBlocks
                            .map((block) => (block.outerHTML || "").replace(/<([^>]+)>/gi, ""))
                            .join(" "),
                    },
                })),
            })))) : (React.createElement(React.Fragment, null))));
};
export default Accordion;
